<template>
    <img :src="img || '/assets/images/logo.png'" alt="" class="rounded1 border1" :width="width">
</template>


<script>
import { ref, watchEffect } from "vue";

import { G } from "@/_common";

export default {
   name: 'SVGLogo',
   props:{
      width: {
         type: Number,
         default: 300
      },
      height: {
         type: Number,
         default: 300
      },
      fill: {
         type: String,
         default: '#146898'
      },
      textFill: {
         type: String,
         default: 'white'
      },
   },
   setup(){
      const img = ref();

      watchEffect(() => {
         img.value = G.systemData && G.systemData.logo !== undefined ? G.systemData.logo.value : '/assets/images/logo.png';
      });

      return {
         img
      };
   }
}
</script>


<style lang="scss" scoped>
</style>
